<template>
  <div class="container-fluid">
      <div class="row">
        <div class="col-12">
            <div class="jumbotron mt-3">
                <h1 class="display-4 text-center">Home</h1>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
  export default {
    name: 'landing-page',
    data () {
      return {}
    },
    computed: {
      session () {
        return this.$store.getters.session
      }
    }
  }
</script>

<style>

</style>
